<template>
  <div class="s1-mezzanine-wrapper mezzanine-is-active">
    <div class="s1-mezzanine" style="z-index: 2">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$store.dispatch('app/MEZZANINE_OPEN');
  },
  destroyed() {
    this.$store.dispatch('app/MEZZANINE_CLOSE');
  }
}
</script>
